

import { combineReducers, configureStore } from '@reduxjs/toolkit';
import userReducer from '../redux/userSlice';
import themeReducer from '../redux/themeSlice';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';


const persistConfig = {
  key: 'root', 
  version: 1,
  storage,
  blacklist: ['sensitiveReducer']
};

const rootReducer = combineReducers({
  user: userReducer,
  thememode: themeReducer
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
 
});

const persistor = persistStore(store);

export { store, persistor };
